import {
    faAngleDown,
    faAnglesUpDown,
    faAngleUp,
    faArrowDown,
    faArrowRight,
    faArrowRightFromBracket,
    faArrowsMaximize,
    faArrowsMinimize,
    faArrowUp,
    faAsterisk,
    faBackwardStep,
    faBarsFilter,
    faBezierCurve,
    faBinarySlash,
    faBrain,
    faBringForward,
    faBringFront,
    faCalculator,
    faCartXmark,
    faCheck,
    faChevronDown,
    faCircle,
    faCircleCheck,
    faCircleInfo,
    faCircleStar,
    faCircleStop,
    faCodeBranch,
    faCopy,
    faCropSimple,
    faCube,
    faDownload,
    faDrawSquare,
    faEye,
    faEyeSlash,
    faFile,
    faFill,
    faFillDrip,
    faFlag,
    faForwardStep,
    faGripDotsVertical,
    faHandPointer,
    faHexagonImage,
    faHourglassHalf,
    faHourglassStart,
    faImage,
    faLasso,
    faMagnifyingGlass,
    faMinus,
    faObjectSubtract,
    faObjectUnion,
    faPalette,
    faPause,
    faPencil,
    faPenRuler,
    faPersonDigging,
    faPersonToDoor,
    faPlay,
    faPlus,
    faRocket,
    faRotate,
    faRotateLeft,
    faRotateRight,
    faRuler,
    faRulerCombined,
    faSendBack,
    faSendBackward,
    faShareNodes,
    faShoppingBasket,
    faSpinnerThird,
    faSquareDashed,
    faSwatchbook,
    faTableColumns,
    faTimes,
    faTrash,
    faTriangleExclamation,
    faUpDownLeftRight,
    faUpRightAndDownLeftFromCenter,
    faUser,
    faUsers,
    faUserSecret,
    faWandMagicSparkles,
    faWrench,
    faX,
    faXmark,
    type IconDefinition,
} from "@fortawesome/pro-light-svg-icons";
import { faEllipsis } from "@fortawesome/pro-light-svg-icons/faEllipsis";

export const lightIcons: IconDefinition[] = [
    faChevronDown,
    faAngleDown,
    faAngleUp,
    faHexagonImage,
    faAnglesUpDown,
    faAsterisk,
    faPencil,
    faArrowRightFromBracket,
    faCheck,
    faTimes,
    faCircleStar,
    faEyeSlash,
    faUsers,
    faPersonDigging,
    faCopy,
    faPalette,
    faCircleCheck,
    faCircleInfo,
    faCircleStop,
    faCodeBranch,
    faBarsFilter,
    faCircle,
    faCartXmark,
    faCalculator,
    faCropSimple,
    faCube,
    faDownload,
    faShareNodes,
    faUser,
    faShoppingBasket,
    faSwatchbook,
    faPersonToDoor,
    faX,
    faFile,
    faFillDrip,
    faEllipsis,
    faUserSecret,
    faHourglassStart,
    faRocket,
    faRotateRight,
    faRuler,
    faRulerCombined,
    faBinarySlash,
    faPenRuler,
    faBezierCurve,
    faBackwardStep,
    faBrain,
    faFlag,
    faForwardStep,
    faPause,
    faPlay,
    faTriangleExclamation,
    faWandMagicSparkles,
    faWrench,
    faMagnifyingGlass,
    // SVG editor
    faArrowsMaximize,
    faArrowsMinimize,
    faBringForward,
    faBringFront,
    faSendBack,
    faSendBackward,
    faHandPointer,
    faUpDownLeftRight,
    faUpRightAndDownLeftFromCenter,
    faRotate,
    faRotateLeft,
    faMinus,
    faPlus,
    faSquareDashed,
    faTableColumns,
    faDrawSquare,
    faFill,
    faLasso,
    // SVG editor colour palette
    faArrowRight,
    faObjectUnion,
    // SVG editor pathfinder
    faObjectSubtract,
    // Vectorization queue
    faArrowDown,
    faArrowUp,
    faEye,
    faGripDotsVertical,
    faHourglassHalf,
    faImage,
    faSpinnerThird,
    faTrash,
    faXmark,
];
